import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { BlogContentPlaceholderInterface } from 'common/types/entities/BlogContentPlaceholderInterface'
import React from 'react'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import HtmlAttrId from '../../../components/core/Sidebar/components/Settings/options/HtmlAttrId'

function BlogContentPlaceholderSettings({
  entity,
}: SettingsProps<BlogContentPlaceholderInterface>) {
  const { isMobile } = useDeviceModeContext()
  const updateProp = useUpdateProp(entity)

  return (
    <>
      <SizeAndPositionGroup
        padding={isMobile ? entity?.mobilePadding : entity.padding}
        updatePadding={updateProp(isMobile ? 'mobilePadding' : 'padding')}
        withoutHorizontalLine
      />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default BlogContentPlaceholderSettings
